import { Component, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService, FilterStateService } from '../../services';
import { IPageResult } from '../../interfaces/page-result';
import { ICustomer } from '../../interfaces/customer';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ICustomerFilter } from '../../interfaces/customer-filter';
import { Table, LazyLoadEvent, SelectItem } from 'primeng';
import { Output } from '@angular/core';

@Component({
  selector: 'app-organisation-selector-grid',
  templateUrl: './organisation-selector-grid.component.html',
  styleUrls: ['./organisation-selector-grid.component.scss'],
})
export class OrganisationSelectorGridComponent implements OnInit {
  constructor(
    private router: Router,
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private filterStateService: FilterStateService,
  ) {}

  @Output() organisationSelected: EventEmitter<number> = new EventEmitter<number>();

  public page: IPageResult<ICustomer> = {
    items: [],
    total: 0,
  };

  public selectedItem;
  public user: string = 'vme';
  public filter: Subject<ICustomerFilter>;
  public filterVal: ICustomerFilter;
  public isLoaded: boolean = false;
  public currentCustomer: ICustomer;
  public filterString: string;
  public organisationtypes: SelectItem[];
  public orgTypeId: number = 0;

  ngOnInit() {
    this.route.data.subscribe((data: any) => {
      this.orgTypeId = data.orgTypeId;
    });

    // Restore filter state
    if (this.filterStateService.orgFilterVal) {
      this.filterVal = Object.assign({}, this.filterStateService.orgFilterVal);
      this.filterStateService.orgFilterVal = null;
    } else {
      this.initDefaultFilter();
    }

    this.getOrganisationTypes();

    this.filter = new Subject<ICustomerFilter>();
    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });
    this.filter.next(this.filterVal);
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 5,
      sortField: 'Name',
      sortOrder: 1,
      filters: {
        name: {},
        addressLine1: {},
        companyRegistrationNumber: {},
        country: {},
        organisationTypeName: {},
        postcode: {},
        town: {},
      },
    };
  }

  load(filter: ICustomerFilter) {
    this.customerService.getPage(filter).then((result) => {
      this.page.items = result.items;
      console.log(result.items);
      this.page.total = result.total;
      this.isLoaded = true;
    });
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;

    this.filter.next(this.filterVal);
  }

  getOrganisationTypes() {
    this.customerService.getTypes().then((result) => {
      this.organisationtypes = [{ label: 'All Organisation Types', value: 0 }];
      if (result != null) {
        result.forEach((item) => {
          if (item.name != 'VME' && item.name != 'Both') {
            this.organisationtypes.push({ label: item.name, value: item.id });
          }
        });
      }
    });
  }

  clearFilter(dt: Table) {
    dt.sortField = '';
    dt.rows = 10;
    this.initDefaultFilter();
    this.filter.next(this.filterVal);
  }

  search() {
    console.log(this.filterVal);
    this.filterVal.first = 0; //fix error - when you set page > 1 and filter, then data not display
    this.filter.next(this.filterVal);
  }

  onOrganisationSelected(event) {
    this.organisationSelected.emit(event.data.id);
  }
}
